import React, { Component, PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { loadLinksData } from '../actions'
import { Map, List, fromJS } from 'immutable'
import { Loader, Message, Dropdown, Popup, Icon, Checkbox } from 'semantic-ui-react'
import fuzzysearch from 'fuzzysearch'

const singleKeyMap = {
  organizations: 'organization_id',
  projects: 'project_id',
  interviews: 'interview_id',
  orders: 'order_id',
}

class LinksTags extends Component {
  shouldComponentUpdate({ valuesMap: nextValuesMap }) {
    let { valuesMap } = this.props
    return !valuesMap.equals(nextValuesMap)
  }

  render() {
    let { onClick, linksData, values } = this.props

    return (
      <div className="links-value" onClick={onClick}>
        <div className="tags">
          {linksData.get('structure', List()).map(level => {
            let org = level.get('organization', Map())
            let org_id = org.get('id')
            let orders = level.get('orders', List())
            let projects = level.get('projects', List())

            return (
              <Fragment key={org_id}>
                {values.organizations.indexOf(org_id) > -1 ? (
                  <span className="tags-item tags-item--blue">{org.get('name')}</span>
                ) : null}
                {projects.size
                  ? projects.map(p => {
                      let project_id = p.get('id')
                      let interviews = p.get('interviews', List())
                      return (
                        <Fragment key={project_id}>
                          {values.projects.indexOf(project_id) > -1 ? (
                            <span className="tags-item tags-item--blue">{p.get('name')}</span>
                          ) : null}
                          {interviews.map(i => {
                            let interview_id = i.get('id')

                            if (values.interviews.indexOf(interview_id) === -1) return null

                            return (
                              <span className="tags-item tags-item--blue" key={interview_id}>
                                {i.get('name')}
                              </span>
                            )
                          })}
                        </Fragment>
                      )
                    })
                  : null}
                {orders.size
                  ? orders.map(o => {
                      let order_id = o.get('id')
                      if (values.orders.indexOf(order_id) === -1) return null

                      return (
                        <span className="tags-item tags-item--purple" key={order_id}>
                          {o.get('name')}
                        </span>
                      )
                    })
                  : null}
              </Fragment>
            )
          })}
        </div>
      </div>
    )
  }
}

class LinksInput extends PureComponent {
  state = {
    open: false,
    search: '',
  }

  componentDidMount() {
    let {
      loadLinksData,
      linksData,
      linksLoading,
      formState: { values },
    } = this.props

    if (linksData.size || linksLoading) return

    loadLinksData()
  }

  getPrefix = () => {
    let { name } = this.props
    name = name.split('.')
    name.pop()
    return name
  }

  getValues = () => {
    let {
      formState: { values },
      multiple = false,
    } = this.props

    let prefix = this.getPrefix()
    let data = prefix.length ? values.getIn(prefix, Map()) : values

    let organizations = []
    let orders = []
    let projects = []
    let interviews = []

    if (multiple && Map.isMap(data)) {
      organizations = data
        .get('organizations', List())
        .map(i => (Map.isMap(i) ? i.get('id') : i))
        .toArray()
      orders = data
        .get('orders', List())
        .map(i => (Map.isMap(i) ? i.get('id') : i))
        .toArray()
      projects = data
        .get('projects', List())
        .map(i => (Map.isMap(i) ? i.get('id') : i))
        .toArray()
      interviews = data
        .get('interviews', List())
        .map(i => (Map.isMap(i) ? i.get('id') : i))
        .toArray()
    } else {
      if (data.get('organization_id')) organizations.push(data.get('organization_id'))

      if (data.get('order_id')) orders.push(data.get('order_id'))

      if (data.get('project_id')) projects.push(data.get('project_id'))

      if (data.get('interview_id')) interviews.push(data.get('interview_id'))
    }

    let hasValues = organizations.length || orders.length || projects.length || interviews.length

    return { organizations, orders, projects, interviews, hasValues }
  }

  handleChange = (area, id) => {
    let { multiple = false, forceOrganization = true, forceProject = false, onChange, linksData } = this.props
    let prefix = this.getPrefix().join('.')
    if (prefix.length) prefix = prefix + '.'

    if (!multiple && !forceProject) forceProject = true

    let values = this.getValues()
    let update = {}
    let plural = `${area}s`
    let areaValues = values[plural] || []
    let data = linksData.get('data', Map())

    if (areaValues.indexOf(id) > -1) {
      areaValues.splice(areaValues.indexOf(id), 1)
    } else {
      if (multiple) {
        areaValues.push(id)
      } else {
        areaValues = [id]
      }

      if (forceOrganization && area !== 'organization') {
        let targetOrganization =
          area === 'interview'
            ? data.getIn([data.getIn([`interview-${id}`, 'parent'], ''), 'organization_id'])
            : data.getIn([`${area}-${id}`, 'organization_id'])
        if (values.organizations.indexOf(targetOrganization) === -1) {
          if (multiple) {
            values.organizations.push(targetOrganization)
          } else {
            values.organizations = [targetOrganization]
          }
          update.organizations = values.organizations
        }
      }

      if (forceProject && area === 'interview') {
        let targetProject = data.getIn([data.getIn([`interview-${id}`, 'parent'], ''), 'id'], false)
        if (targetProject && values.projects.indexOf(targetProject) === -1) {
          if (multiple) {
            values.projects.push(targetProject)
          } else {
            values.projects = [targetProject]
          }
          update.projects = values.projects
        }
      }
    }

    update[plural] = areaValues

    if (forceOrganization && update.organizations) {
      for (let area in values) {
        if (area === 'organizations') continue

        let currentData = update[area] || values[area] || []

        if (!Array.isArray(currentData)) currentData = []

        let areaData = currentData.concat([])
        let singular = area.substr(0, area.length - 1)

        for (let id of areaData) {
          let organization_id =
            singular === 'interview'
              ? data.getIn([data.getIn([`interview-${id}`, 'parent'], ''), 'organization_id'])
              : data.getIn([`${singular}-${id}`, 'organization_id'])

          if (update.organizations.indexOf(organization_id) === -1) {
            areaData.splice(areaData.indexOf(id), 1)
          }
        }

        if (areaData.length !== currentData.length) update[area] = areaData
      }
    }

    if (forceProject && update.projects) {
      let checkInterviews = []
      let interviews = update.interviews || values.interviews
      for (let interview_id of interviews) {
        let project_id = data.getIn([`interview-${interview_id}`, 'project_id'], false)
        if (update.projects.indexOf(project_id) > -1) checkInterviews.push(interview_id)
      }
      if (checkInterviews.length !== interviews.length) update.interviews = checkInterviews
    }

    for (let areaKey in update) {
      if (!multiple) {
        let singleKey = singleKeyMap[areaKey]
        update[prefix + singleKey] = (update[areaKey] || [])[0] || null
      } else {
        update[prefix + areaKey] = fromJS(update[areaKey].map(id => ({ id })))
      }
      if (prefix.length) delete update[areaKey]
    }

    update = Object.keys(update).map(k => ({ name: k, value: update[k] }))
    onChange(update, true)
  }

  render() {
    let { multiple = false, linksData, linksLoading } = this.props
    let { open, search } = this.state

    if (linksLoading || !linksData.size) return <Icon name="spinner" loading />

    let { hasValues, ...values } = this.getValues()
    let valuesMap = fromJS(values)

    if (!hasValues) open = true

    let classes = ['form-input--links', 'links-input']

    if (open) classes.push('links-input--open')

    return (
      <div className={classes.join(' ')}>
        {hasValues ? (
          <LinksTags
            onClick={e => e.preventDefault() & this.setState({ open: open === false })}
            linksData={linksData}
            values={values}
            valuesMap={valuesMap}
          />
        ) : null}
        {open ? (
          <div className="links-choose">
            <div className="links-choose-search">
              <input
                type="text"
                value={search}
                onChange={e => this.setState({ search: e.target.value })}
                id="links-search"
                placeholder="Hae linkkejä"
              />
              <label htmlFor="links-search">
                <Icon name="search" />
              </label>
            </div>
            {linksData.get('structure', List()).map(level => {
              let org = level.get('organization', Map())
              let org_id = org.get('id')
              let orders = level.get('orders', List())
              let projects = level.get('projects', List())
              let checked = values.organizations.indexOf(org_id) > -1
              let visible = search.trim() === '' || fuzzysearch(search.toLowerCase(), org.get('name', '').toLowerCase())

              return (
                <div className="links-choose-organization" key={org_id}>
                  {visible ? (
                    <div className="links-choose-item">
                      <div className="links-choose-item-value">
                        <Checkbox
                          checked={checked}
                          radio={multiple === false}
                          onChange={() => this.handleChange('organization', org_id)}
                        />
                        <button onClick={e => e.preventDefault() & this.handleChange('organization', org_id)}>
                          {org.get('name')}
                        </button>
                      </div>
                    </div>
                  ) : null}
                  {projects.size ? (
                    <div className="links-choose-area">
                      <div className="links-choose-area-title">Projektit</div>
                      <div className="links-choose-area-list">
                        {projects.map(p => {
                          let project_id = p.get('id')
                          let checked = values.projects.indexOf(project_id) > -1
                          let interviews = p.get('interviews', List())
                          let visible =
                            search.trim() === '' || fuzzysearch(search.toLowerCase(), p.get('name', '').toLowerCase())
                          return (
                            <div className="links-choose-item" key={project_id}>
                              {visible ? (
                                <div className="links-choose-item-value">
                                  <Checkbox
                                    checked={checked}
                                    radio={multiple === false}
                                    onChange={() => this.handleChange('project', project_id)}
                                  />
                                  <button onClick={e => e.preventDefault() & this.handleChange('project', project_id)}>
                                    {p.get('name')}
                                  </button>
                                </div>
                              ) : null}
                              <div className="links-choose-area">
                                {interviews.map(i => {
                                  let interview_id = i.get('id')
                                  let checked = values.interviews.indexOf(interview_id) > -1
                                  let visible =
                                    search.trim() === '' ||
                                    fuzzysearch(search.toLowerCase(), i.get('name', '').toLowerCase())

                                  if (!visible) return null

                                  return (
                                    <div className="links-choose-item-value" key={interview_id}>
                                      <Checkbox
                                        checked={checked}
                                        radio={multiple === false}
                                        onChange={() => this.handleChange('interview', interview_id)}
                                      />
                                      <button
                                        onClick={e =>
                                          e.preventDefault() & this.handleChange('interview', interview_id)
                                        }>
                                        {i.get('name')}
                                      </button>
                                    </div>
                                  )
                                })}
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  ) : null}
                  {orders.size ? (
                    <div className="links-choose-area">
                      <div className="links-choose-area-title">Tilaukset</div>
                      <div className="links-choose-area-list">
                        {orders.map(o => {
                          let order_id = o.get('id')
                          let checked = values.orders.indexOf(order_id) > -1

                          let visible =
                            search.trim() === '' || fuzzysearch(search.toLowerCase(), o.get('name', '').toLowerCase())

                          if (!visible) return null

                          return (
                            <div className="links-choose-item" key={order_id}>
                              <div className="links-choose-item-value">
                                <Checkbox
                                  checked={checked}
                                  radio={multiple === false}
                                  onChange={() => this.handleChange('order', order_id)}
                                />
                                <button onClick={e => e.preventDefault() & this.handleChange('order', order_id)}>
                                  {o.get('name')}
                                </button>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  ) : null}
                </div>
              )
            })}
          </div>
        ) : null}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    linksData: state.formData.get('_linksData', Map()),
    linksLoading: state.formData.get('_linksLoading', false),
    linksError: state.formData.get('_linksError', false),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    loadLinksData: (id, options) => dispatch(loadLinksData(id, options)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LinksInput)
